import React from 'react';
import PropTypes from 'prop-types';
import PinInput from 'react-pin-input';

import { Typography, colors, colorsV1, LoaderAnimate } from '@ajaibid/components';
import { PopUpCenterV2 } from 'Component/PopUp';

import PIN_IMAGE from 'Image/PIN/PIN.png';
import { styBoxContainer, styContainer } from './style';

export const CreatePinBox = ({
  title,
  description,
  errorMessage,
  length,
  onComplete,
  isLoading,
}) => (
  <div className={styContainer}>
    <div className={styBoxContainer(true)}>
      <div data-testid="pin-image">
        <img src={PIN_IMAGE} alt="" width="300px" />
      </div>
      <Typography
        type="heading"
        size="sm"
        bold
        style={{ marginTop: '40px' }}
        data-testid="pin-title"
      >
        {title}
      </Typography>
      <Typography
        type="body"
        size="lg"
        style={{ fontSize: '18px', marginTop: '16px' }}
        data-testid="pin-subtitle"
      >
        {description}
      </Typography>

      <PinInput
        length={length}
        secret
        type="numeric"
        inputMode="number"
        style={{ padding: '10px' }}
        inputStyle={{
          borderColor: errorMessage ? colors.RED_5 : colors.NEUTRAL_1,
          backgroundColor: colorsV1.primaryBackground,
          borderRadius: '4px',
          color: errorMessage ? colors.RED_5 : colors.AJAIB_BLUE_4,
          fontSize: '25px',
          margin: '0px 4px',
          paddingBottom: '2px',
        }}
        inputFocusStyle={{ borderColor: colors.AJAIB_BLUE_4 }}
        onComplete={(value) => {
          onComplete(value);
        }}
        focus
        autoSelect
      />

      {errorMessage && (
        <Typography
          type="label"
          size="md"
          style={{ color: colors.RED_4, textAlign: 'center' }}
          data-testid="pin-error"
        >
          {errorMessage}
        </Typography>
      )}

      <Typography
        type="body"
        size="md"
        style={{ color: colorsV1.contentSecondary, marginTop: '56px' }}
        data-testid="pin-notice"
      >
        Gunakan PIN dengan kombinasi yang tidak mudah ditebak.
      </Typography>
    </div>
    {isLoading && (
      <PopUpCenterV2 show width="auto">
        <div data-testid="pin-loader">
          <LoaderAnimate width="58px" height="58px" />
        </div>
      </PopUpCenterV2>
    )}
  </div>
);

CreatePinBox.propTypes = {
  title: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
  errorMessage: PropTypes.string,
  length: PropTypes.number,
  onComplete: PropTypes.func.isRequired,
  isLoading: PropTypes.bool,
};

CreatePinBox.defaultProps = {
  errorMessage: '',
  length: 4,
  isLoading: false,
};
